let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("adUnw")).then(() => parcelRequire('2S1ZA'));